<template lang="pug">
.c-article-page
  article-section(:article="article")
</template>

<script>
import SectionBanner from "@/components/SectionBanner.vue";
import ArticleSection from "@/components/ArticleSection.vue";

export default {
  name: "ArticlePage",
  components: {
    SectionBanner,
    ArticleSection
  },
  data() {
    return {
      article: null
    };
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    id() {
      return this.$route.params.id;
    }
  },
  async created() {
    const payload = {
      type: this.type,
      id: this.id
    };
    const found = this.$store.getters["article/findItem"](payload);

    if (found) {
      this.article = found;
    } else {
      const article = await this.fetchData(this.id);
      this.article = article;
    }
  },
  methods: {
    async fetchData(id) {
      const doc = await this.$f.db
        .collection("articles")
        .doc(id)
        .get();
      return this.$u.parseDbSnap(doc);
    }
  }
};
</script>

<style module lang="sass">
.sub
  div
    display: inline-block
</style>
